/**
 * Created by Administrator on 2018/4/22 0022.
 */
/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import DmsTab from '../../components/dmsTab';
import { Button, Row, Col, Tabs, Rate, Popover, Radio, InputNumber, Select, Input, Checkbox,Upload ,Icon} from 'antd';
import '../product/product.css';
import { openNotice, config,APIS } from 'Utils';
const imgData = {
  'photoImg': require('../../assets/images/ic-dy-man03.png')
};
import { getProductDetails} from '../../service/product';
import {orderEvaluationInsert} from '../../service/order';
class Evaluation extends React.Component {
  constructor(props) {
    super(props);
    this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
    this.state = {
      opts: ['订单评价'],
      selectImgIndex: 0,
      detailData: {},
      priceStock: {
        'price': 0,
        'suggestedPrice': 0,
        'stock': 0
      },
      commentData: {
        content:'',
        anonymous:false,
        evalute:0
      },
      bentiMsg: [],     //本体
      fujianMsg: [],    //附件
      inventory: '',      //库存
      fileList:[]
    }
  }

  updateBigImg(index, qst) {
    /* 修改大图显示 */
    this.setState({ selectImgIndex: index });
    this.setState({
      'detailData': {
        ...this.state.detailData,
        'bigImg': qst.fileCompressPath
      }
    });
  }

  onChangeInput=(e)=> {
    const target=e.target;
    const {commentData}=this.state;
    this.setState({
      commentData:{...commentData,[target.name]:target.value}
    });
  };

  onChangeCheck=(e)=> {
    const target=e.target;
    // console.log(target)
    const {commentData}=this.state;
    this.setState({
      commentData:{...commentData,anonymous:target.checked}
    });
  };
  componentDidMount() {
    let self = this;
    let orderId = this.props.params.orderId;
    getProductDetails({ id: orderId }).then(function (result) {
      if (result && result.code == 200) {
        let detailData = result.data || {};
        detailData.bigImg = detailData.picUrls && detailData.picUrls.length > 0 ? detailData.picUrls[0].filePath : '';
        let jsonObject = JSON.parse(detailData.jsonObject || '[]');
        let selectArr = [];
        for (let spec of jsonObject) {
          let selectData = [];
          for (let data of spec.data) {
            if (data.selected) {
              data.selected = false;
              selectData.push(data);
            }
          }
          if (selectData.length > 0) {
            selectArr.push({
              'text': spec.text,
              'code': spec.code,
              'data': selectData
            });
          }
        }
        detailData.jsonObject = selectArr;
        detailData.categoryText = (detailData.categoryText || '').replace(/,/g, '-');
        self.setState({
          'detailData': detailData,
          'bentiMsg': detailData.categoryTypeVo.bentiMsg, /* 本体 */
          'fujianMsg': detailData.categoryTypeVo.fujianMsg, /* 附件 */
        });
        self.setState({
          'priceStock': {
            'price': detailData.showPrice,
            'suggestedPrice': detailData.suggestedPrice,
            'stock': (detailData.inventory || 0) + ' ' + detailData.unitText
          }
        });
      } else {
        openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
      }
    });
  };

  backHandle() {
    window.history.go(-1);
  }

  componentWillMount() {

  };

  openImg(path) {
    window.open(path);
  }
  changeStar=(value,type)=>{
    const {commentData}=this.state;
    this.setState({
      commentData:{...commentData,[type]:value}
    });
  };
  submitEvalute=()=>{
    const {commentData,fileList}=this.state;
    const picFileIdList=[];
    fileList.forEach(item=>{
      item&&picFileIdList.push(item.response.data.id);
    });
    const orderId = this.props.params.orderId;
    const orderProductId = this.props.params.orderProductId;
    const param={
      score:commentData.evalute,
      evaluation:commentData.content,
      picFileIdList,
      orderId,
      orderProductId,
      isAnonymity:commentData.anonymous?1:0
    }
    if(!param.score){
      openNotice('error', '请选择评分');
      return false;
    }
    if(!param.evaluation){
      openNotice('error', '请填写评价内容');
      return false;
    }
    orderEvaluationInsert({productEvaluationList:[param]}).then(res=>{
      if(res.code===200){
        openNotice('success', '评价成功');
        this.backHandle();
      }else{
        openNotice('error', '评价失败', (res && res.message) ? res.message : '');
      }
    });
  }
  render() {
    const { opts, detailData, selectImgIndex, commentData, priceStock } = this.state;
    let self = this;
    let imgHtml = (detailData.picUrls || []).map(function (qst, key) {
      return <img className={selectImgIndex == key ? 'selected' : ''}
                  onMouseOver={self.updateBigImg.bind(self, key, qst)} alt="" src={config.server + qst.fileCompressPath}
                  key={key} />
    });
    const props = {
      action: APIS.upload,
      listType: 'picture',
      onRemove(file){
         self.setState({
          fileList:file.fileList
        });
      },
      onChange(file){
        self.setState({
          fileList:file.fileList
        });
      }
    };
    return <div>
      <DmsTab options={opts} defaultKey={0}>
        <Button onClick={this.backHandle.bind(this)}>返回</Button>
      </DmsTab>
      <div className="dms-table-box" style={{ padding: 0 }}>
        <div style={{ position: 'relative', padding: '12px 0 12px 372px' }}>
          <div className="detail_img" style={{ height: '300px' }}>
            <img src={config.server + (detailData.bigImg || '')} alt="" />
            <div className="small_scroll">
              {imgHtml}
            </div>
          </div>
          <div className="detail_field" style={{ height: '300px', minHeight: 'auto' }}>
            <div className="na">{detailData.name}</div>
            <div className="pri">
              <p className="d">牌价<span>¥{priceStock.price}</span></p>
              <div className="ri" style={{ right: '100px' }}>
                <span>{detailData.viewCount || 0}</span><br />
                <span>浏览量</span>
              </div>
              <div className="ri">
                <span>{detailData.viewCount || 0}</span><br />
                <span>销量</span>
              </div>
            </div>
            <div className="de">
              <ul className="left">
                <li>
                  <label>物料编码</label>
                  <p>{detailData.itemNum||'--'}</p>
                </li>
                <li>
                  <label>单位</label>
                  <p>{detailData.unit||'--'}</p>
                </li>
                <li>
                  <label>最小装箱数</label>
                  <p>{detailData.minPackageQuantity||'--'}</p>
                </li>
                <li>
                  <label>装箱数</label>
                  <p>{detailData.packageQuantity||'--'}</p>
                </li>
                {/* <li>
                  <label>每小盒数量</label>
                  <p>{detailData.sortOrder}</p>
                </li> */}
              </ul>
              <ul className="right">
                <li>
                  <label>物料大类</label>
                  <p>{detailData.proBigName||'--'}</p>
                </li>
                <li>
                  <label>库存类型</label>
                  <p>{detailData.stockType||'--'}</p>
                </li>
                <li>
                  <label>最小起订量</label>
                  <p>{detailData.minOrderQuantity||'--'}</p>
                </li>
                <li>
                  <label>产品线</label>
                  <p>{detailData.proLine||'--'}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="detail_other tab_individual">
          <div className="product_comment">
            <div className="star" style={{height:'130px'}}>
              <Row>
                <Col span={6}>
                  <Row>
                    <Col span={4}>
                      <span style={{lineHeight:'30px'}}>评分</span>
                    </Col>
                    <Col span={20}>
                      <Rate value={commentData.evalute} onChange={(value)=>{this.changeStar(value,'evalute')}}/>
                    </Col>
                  </Row>
                </Col>
                <Col span={18}>
                  <Upload {...props} className="upload-list-inline">
                    <Button type="ghost">
                      <Icon type="upload" />点击上传
                    </Button>
                  </Upload>
                </Col>
              </Row>
            </div>
            <div className="textarea">
              <Input type="textarea" rows={4} placeholder="输入评论" name='content' onChange={this.onChangeInput}/>
            </div>
            <div style={{ textAlign: 'center', height: '45px' }}>
              <Checkbox onChange={this.onChangeCheck}>匿名评论</Checkbox>
              <Button onClick={this.submitEvalute}>提交评价</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
export default Evaluation;



// WEBPACK FOOTER //
// ./src/routes/order/evaluate.js